import { postLogoutRedirectUri, msalConfig } from '../../config/msalConfig';

export default function idleTimer(msalInstance) {
    let t; // Timeout reference
    const homeAccount = JSON.parse(window.sessionStorage.getItem('home_account'));

    // Logout logic
    function idle() {
        if (homeAccount) {
            const currentAccount = msalInstance.getAccountByHomeId(homeAccount?.homeAccountId);
            msalInstance.logout({
                account: currentAccount,
                postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,
                authority: msalConfig.auth.authority,
            });
        }
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = '/login';
    }

    // Reset the timer
    function resetTimer() {
        clearTimeout(t); // Clear the previous timeout
        t = setTimeout(idle, 1800000); // Set a new timeout
    }

    // Attach event listeners to detect user activity
    function setupActivityListeners() {
        const events = [
            'mousemove', // Detect mouse movement
            'mousedown', // Detect mouse button press
            'click',     // Detect mouse clicks
            'scroll',    // Detect scrolling
            'keypress',  // Detect keyboard input
        ];

        // Add resetTimer to all events
        events.forEach(event => window.addEventListener(event, resetTimer));
    }

    // Initialize the idle timer
    function initialize() {
        resetTimer(); // Start the timer
        setupActivityListeners(); // Attach listeners
    }

    initialize(); // Start the idle timer logic
}



 
